<template>
  <v-container id="project-summary" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <idc-component-bid-summary :type="status" :statuses="bidStatuses" :title="title" :sub-header="subHeader" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { ManagementStatus } from '@/utilities/bid/enums/Status'

  export default Vue.extend({
    name: 'DashboardLiveSummary',
    components: {
      IdcComponentBidSummary: () => import('@/components/idc/bids/Summary'),
    },
    props: {
      bidStatuses: {
        type: Array,
        default: () => [16, 17, 18, 19, 20, 21, 22, 23, 25, 26],
      },
    },
    data: () => ({
      status: ManagementStatus.STATUS_TYPE_LIVE,
      title: 'Project Summary',
      subHeader: 'Projects',
    }),
  })
</script>

<style lang="sass">
  section#project-summary
    .v-card--material
      &__heading.success
        background-color: $dark-red-colour !important
        border-color: $dark-red-colour !important
</style>
